import { jsx, jsxs } from 'react/jsx-runtime';
import { Accordion } from '../../display/Accordion/Accordion.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';

const root = "_root_1qjbr_1";
const faqContent = "_faq-content_1qjbr_10";
const heading = "_heading_1qjbr_15";
const ctaContainer = "_cta-container_1qjbr_21";
const grid = "_grid_1qjbr_36";
const styles = {
	root: root,
	faqContent: faqContent,
	heading: heading,
	ctaContainer: ctaContainer,
	grid: grid
};

const FAQ = ({ heading = "Frequently Asked Questions", items, children, ctaText, ctaHref, onCtaClick }) => {
  return jsx("div", { className: styles.root, "data-zds": true, children: jsxs("div", { className: styles.faqContent, "data-zds": true, children: [jsx(HeadingLevel, { children: jsx(Heading, { className: styles.heading, children: heading }) }), items && items.length > 0 ? jsx("div", { className: styles.grid, "data-zds": true, children: items.map((item) => jsx(Accordion, { title: item.title, href: item.href, isInitiallyOpen: item.isInitiallyOpen, isOpen: item.isOpen, onToggle: item.onToggle, children: item.content }, item.title)) }) : children, ctaText && (ctaHref || onCtaClick) && jsx("div", { className: styles.ctaContainer, "data-zds": true, children: jsx(LegacyButton, { href: ctaHref, size: "medium", onClick: onCtaClick, children: ctaText }) })] }) });
};

export { FAQ };
//# sourceMappingURL=FAQ.es.js.map
